import React, { PropTypes, Component } from 'react';
import SimpleTemplateList from '../template-list/simple-template-list';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import { RaisedButton, Dialog, FontIcon, CircularProgress } from 'material-ui';
import {
  sendUpdatesFromQueue as sendUpdatesFromQueueAction,
  clearState as clearStateAction,
} from './__storeFiles__/actions';

const propTypes = {
  templates: PropTypes.array,
  sendUpdatesFromQueue: PropTypes.func,
  clearState: PropTypes.func,
  sendingUpdates: PropTypes.bool,
  updateProcessInitiated: PropTypes.bool,
  error: PropTypes.string,
};

class SupplierUpdatesQueueRouter extends Component {
  constructor() {
    super();
    this.state = {
      openDialog: false,
      subject: '',
    };
  }
  openDialog = () => this.setState({ openDialog: true });
  closeDialog = () => {
    this.setState({ openDialog: false, subject: '' });
    this.props.clearState();
  }
  updateSubject = ({ target: { value } }) => this.setState({ subject: value });
  sendUpdatesFromQueue = () => {
    const templateIds = this.props.templates
      .filter(obj => obj.stagedUpdates && obj.stagedUpdates.length)
      .map(obj => obj._id);
    this.props.sendUpdatesFromQueue(templateIds, this.state.subject);
  };
  render() {
    const { templates = [], sendingUpdates, updateProcessInitiated, error } = this.props;
    const { openDialog, subject } = this.state;
    const queuedTemplates = templates.filter(obj => obj.stagedUpdates && obj.stagedUpdates.length);
    const queuedNonInitiatedTemplates = templates.filter(obj => obj.stagedUpdates && obj.stagedUpdates.length && !obj.updateInitiated);
    return (
      <div>
        <div
          className="flex-tc-sb"
          style={{
            height: '51px',
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            padding: '0 16px',
            borderBottom: '1px solid #e0e0e0',
          }}
        >
          <span style={{ lineHeight: '51px' }}>
            You have {queuedTemplates.length} {pluralize('template', queuedTemplates.length)} queued
            for updates.
          </span>
          <RaisedButton
            secondary
            disabled={!queuedNonInitiatedTemplates.length}
            onTouchTap={this.openDialog}
            label="Send All Updates"
          />
        </div>
        {Boolean(queuedTemplates.length) && <SimpleTemplateList templates={queuedTemplates} />}
        <Dialog
          open={openDialog}
          contentStyle={{ width: '450px', padding: '16px 8px' }}
          onRequestClose={this.closeDialog}
          modal
          actionsContainerStyle={{ textAlign: 'center', paddingBottom: '24px' }}
          actions={[
            <RaisedButton
              key="1"
              secondary
              disabled={sendingUpdates || !subject}
              label={updateProcessInitiated ? 'Dismiss' : 'Send'}
              onTouchTap={updateProcessInitiated ? this.closeDialog : this.sendUpdatesFromQueue}
            />,
          ]}
        >
          <div style={{ textAlign: 'right', marginBottom: '12px' }}>
            <FontIcon
              className="tc-icon-close"
              style={{ cursor: 'pointer', display: sendingUpdates ? 'none' : 'default' }}
              onClick={this.closeDialog}
            />
          </div>
          {(() => {
            if (sendingUpdates) {
              return (
                <div style={{ textAlign: 'center' }}>
                  <CircularProgress style={{ margin: 'auto' }} size={50}/>
                  <br/>
                  Please hold...
                </div>
              );
            }
            if (updateProcessInitiated) {
              return 'Great! We have received your request and are processing your updates. Feel free to continue working in the system.';
            }
            if (error) return error;
            return (
              <div>
                <b style={{ color: 'rgba(0, 0, 0, 0.64)' }}>Please add a subject:</b>
                <input
                  value={subject}
                  autoFocus
                  onChange={this.updateSubject}
                  style={{
                    width: '87%',
                    height: '24px',
                    marginTop: '8px',
                    marginBottom: '16px',
                    paddingLeft: '4px',
                  }}
                />
                Templates to be updated:
                {
                  queuedTemplates.map(template => (
                    <div
                      key={template._id}
                      style={{ fontSize: '12px' }}
                    >
                      <FontIcon
                        className="tc-icon-attach_file"
                        style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.44)' }}
                      />&nbsp;
                      {template.templateName}
                    </div>
                  ))
                }
              </div>
            );
          })()}
        </Dialog>
      </div>
    );
  }
}

SupplierUpdatesQueueRouter.propTypes = propTypes;

const mapStateToProps = ({ contracting }) => ({
  templates: contracting.templateList.toJS().templates,
  ...contracting.supplierUpdatesQueue,
});

export default connect(
  mapStateToProps,
  {
    sendUpdatesFromQueue: sendUpdatesFromQueueAction,
    clearState: clearStateAction,
  },
)(SupplierUpdatesQueueRouter);



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-updates-queue/router.jsx